import { isEmpty } from "@core-ui/helpers/Utils";
import { CouponMessageCard } from "@core-ui/interfaces/Common";
import { replaceAllOccurence } from "@core-ui/utils/String";

export const getAriaLabel = (textToShowInMiddle: string, data: CouponMessageCard): string => {
    let ariaLabel = "";
    if (textToShowInMiddle || data.title) ariaLabel = data.title;
    if (textToShowInMiddle) ariaLabel = ariaLabel.concat(", ", textToShowInMiddle);
    if (!isEmpty(textToShowInMiddle) && !isEmpty(data.secondaryDiscountCallout))
        ariaLabel = ariaLabel.concat(", ", data.secondaryDiscountCallout);
    if (!isEmpty(data.description)) ariaLabel = ariaLabel.concat(". ", data.description);

    return replaceAllOccurence(ariaLabel, "₹", "rupees ");
};

export const APPLY_COUPON_MODAL_TEST_IDS = {
    CART_APPLY_COUPON_MODAL: "CART_APPLY_COUPON_MODAL",
    CART_APPLY_COUPON_MODAL_TEXT: "CART_APPLY_COUPON_MODAL_TEXT",
    CART_APPLY_COUPON_MODAL_CLOSE: "CART_APPLY_COUPON_MODAL_CLOSE",
    CART_APPLY_COUPON_DESCRIPTION: "CART_APPLY_COUPON_DESCRIPTION",
    CART_APPLY_COUPON_MODAL_PRIMARY_TEXT: "CART_APPLY_COUPON_MODAL_PRIMARY_TEXT",
    CART_APPLY_COUPON_MODAL_IMG: "CART_APPLY_COUPON_MODAL_IMG",
};
